import React from "react";
import { useNavigate } from "react-router-dom";

const NavigationLinks = ({ SVG, text, route }) => {
  const navigate = useNavigate();
  return (
    <div
      data-bs-dismiss="offcanvas"
      onClick={() => {
        navigate(route);
      }}
      style={{ padding: "6px 16px", gap: "0.5rem", borderRadius: "8px" }}
      className="d-flex justify-content-between w-100 align-items-center bg-white"
    >
      <div>
        <SVG />
      </div>
      <div
        className="w-100 textColor"
        style={{
          fontFamily: "Inter",
          fontSize: "1.125rem",
          lineHeight: "100%",
          letterSpacing: "0%",
        }}
      >
        {text}
      </div>
    </div>
  );
};

export default NavigationLinks;
